const capitalizeFirstLetter = ([first, ...rest]) => first.toUpperCase() + rest.join('')
export default capitalizeFirstLetter
